var _rect, _line, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayCheckboxSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 2.5,
    fill: "#B7B7B7",
    stroke: "#B7B7B7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.60104,
    y1: 5.46341,
    x2: 5.07378,
    y2: 7.93615,
    stroke: "#656565",
    strokeWidth: 1.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17665 8.24299L9.41832 2.99959",
    stroke: "#656565",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCheckboxSelected);
export default __webpack_public_path__ + "static/media/grayCheckboxSelected.9b3810246950b8134b710110b4b6257c.svg";
export { ForwardRef as ReactComponent };